import { Icon } from '@design/components/icon/Icon';
import { useUnreadAlertsCount } from '@terminal/react-query-hooks/events/use-event-alerts/useUnreadAlertsCount';
import { useTranslation } from 'react-i18next';

import styles from './AlertsIcon.module.scss';

const getUnreadBadgeLabel = (count: number) => {
  if (count < 1) {
    return;
  }

  if (count > 9) {
    return '9+';
  }

  return count;
};

export const AlertsIcon = () => {
  const { t } = useTranslation(['common']);
  const unreadCount = useUnreadAlertsCount();
  const alertsLabel = t('common:sideNavigation.alerts');
  const badgeLabel = getUnreadBadgeLabel(unreadCount);
  const ariaLabel = badgeLabel ? `${alertsLabel} ${badgeLabel}` : alertsLabel;

  return (
    <div className={styles.alertsIconRoot} role="img" aria-label={ariaLabel}>
      <Icon iconName="NotificationLine" size={24} />
      {badgeLabel && (
        <span className={styles.unreadBadge} aria-hidden="true">
          {badgeLabel}
        </span>
      )}
    </div>
  );
};
